import React from 'react';
import styled from 'styled-components';
import Required from './required';

const InputLabel = ({ required, children, ...props }) => (
  <span {...props}>{children}{required && <Required />}</span>
);

export default styled(InputLabel)``;
